import { render, staticRenderFns } from "./CancellationOptin.vue?vue&type=template&id=981fea16&scoped=true"
import script from "./CancellationOptin.vue?vue&type=script&lang=js"
export * from "./CancellationOptin.vue?vue&type=script&lang=js"
import style0 from "./CancellationOptin.vue?vue&type=style&index=0&id=981fea16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981fea16",
  null
  
)

export default component.exports